import React from "react";
import { CancelAppointment } from "./CancelAppointment";
import { services } from "../../data/services";
import { parseDateKey } from "../../utils/slots";
import { formatLongDate, formatMonthShort, formatTime } from "../../utils/format";
import type { Appointment } from "../../types/booking";
interface AppointmentRowProps {
  appointment: Appointment;
  variant: "upcoming" | "history";
}
export function AppointmentRow({
  appointment,
  variant
}: AppointmentRowProps) {
  const service = services.find(s => s.id === appointment.serviceId);
  const date = parseDateKey(appointment.dateKey);
  const cancelled = appointment.status === "cancelled";
  return <li className="flex flex-col gap-4 py-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-19" data-mp="8q07jpzzyr0l">
      <div className="flex items-center gap-4" data-id="element-20" data-mp="dothj8g2rzw0">
        <div className={`flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-2xl ${variant === "upcoming" ? "bg-brand-soft text-brand" : "bg-surface text-muted"}`} data-id="element-21" data-mp="3uyrq2a1a0su6">
          <span className="text-lg font-semibold leading-none" data-id="element-22" data-mp="36gxdsaknp82n">{date.getDate()}</span>
          <span className="mt-0.5 text-xs" data-id="element-23" data-mp="31im1zuaswnhs">{formatMonthShort(date)}</span>
        </div>
        <div data-id="element-24" data-mp="3fi5aio7iy0um">
          <p className={`font-medium ${cancelled ? "text-muted line-through" : "text-ink"}`} data-id="element-25" data-mp="3fhvm3524o1r1">
            {service?.name ?? "Soin"}
          </p>
          <p className="mt-0.5 text-sm text-muted" data-id="element-26" data-mp="2ns0ji6p9efkf">
            {formatLongDate(date)} à {formatTime(appointment.time)}
          </p>
        </div>
      </div>
      {variant === "upcoming" ? <CancelAppointment appointment={appointment} data-id="element-27" data-mp="2ir3421vmvzmm" /> : <span className={`self-start rounded-full px-3 py-1 text-xs font-medium sm:self-auto ${cancelled ? "bg-danger/5 text-danger" : "bg-surface text-muted"}`} data-id="element-28" data-mp="2wlvn3aaqfxxy">
          {cancelled ? "Annulé" : "Effectué"}
        </span>}
    </li>;
}